import type { Metadata } from "next";
import AdminPrivacyPolicy from "@/Component/Admin/ContentManagement/PrivacyPolicy";

export const metadata: Metadata = {
    title: "Privacy Policy | Connector Club",
};
const PrivacyPolicyPage = () => {
    return (
        <AdminPrivacyPolicy />
    )
}

export default PrivacyPolicyPage
